import { createProvinceRequest } from "../../data/provinceApi";
import { validateProvincePayload } from "../validator/validateProvincePayload";

export async function createProvinceUseCase(payload) {
  const error = validateProvincePayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await createProvinceRequest(payload);
}
